import { Box, SxProps } from "@mui/material";
import type { ReactNode } from "react";
import { ThemeV2 } from "src/util/types";
import { useThemeContext } from "../../globalContext/global-context";
import type { QuestionArrangement } from "../../questions/contracts";
import ChoiceGroup from "../ui/ChoiceGroup";

export const ChoiceInstrument = ({
  arrangement,
  isList,
  children,
}: {
  arrangement: QuestionArrangement;
  isList: boolean;
  children: ReactNode;
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box
      sx={optionContainer(theme)}
      data-select-view={isList ? "list" : undefined}
    >
      <ChoiceGroup isLandscapeMode={arrangement === "wide"} isList={isList}>
        {children}
      </ChoiceGroup>
    </Box>
  );
};

export const DropdownInstrument = ({ children }: { children: ReactNode }) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box sx={optionContainer(theme)} data-select-view="dropdown">
      {children}
    </Box>
  );
};

export const optionContainer = (theme: ThemeV2): SxProps => ({
  width: "100%",
  padding: `${theme.tokens.spacing["2"]}px`,
  display: "flex",
  justifyContent: "center",
  alignItems: "end",
  flexDirection: "column",
  gap: `${theme.tokens.spacing["2"]}px`,
});
